import { render } from "./DetailUserView.vue?vue&type=template&id=143de24a"
import script from "./DetailUserView.vue?vue&type=script&lang=js"
export * from "./DetailUserView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__